import type { GiftPlanType } from '~/types/resources/ClientType';

type IFormatGiftPlan = (giftPlan: GiftPlanType | null) => string;

/**
 * ギフトプランをフォーマットして文字列として返す
 *
 * 同名企業・複数プランでも発行対象を識別できるよう、企業選択の候補行に
 * サブラベルとして表示する契約プラン情報を生成する。
 *
 * @param giftPlan - ギフトプラン情報（nullの場合は「-」を返す）
 * @returns フォーマット済みのギフトプラン文字列
 * @example
 * formatGiftPlan({ amount: 1000, months_interval: 3 })
 * // => "1000円（3ヶ月に1回 利用可）"
 */
export const formatGiftPlan: IFormatGiftPlan = giftPlan =>
  giftPlan ? `${giftPlan.amount}円（${giftPlan.months_interval}ヶ月に1回 利用可）` : '-';
